enum CvnaTier {
  basic = 'basic',
  notable = 'notable',
  standout = 'standout'
}

export default CvnaTier;
